import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {CardButtonComponent} from '../card-button/card-button.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-card-title',
  templateUrl: './card-title.component.html',
  styleUrls: ['./card-title.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, CardButtonComponent, TranslateModule],
})
export class CardTitleComponent implements OnInit {
  @Input() title: string | undefined;
  @Input() color: string = '#4f4f4f';

  constructor() {
  }

  ngOnInit() {
  }
}
